// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../node_modules/@rmwc/circular-progress/circular-progress.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-modal-card-ek0XE {
  width: 312px;
  min-height: 0px;
  height: 212px;
}

.loading-modal-modalToolbar_container-QqL2y {
  border-bottom: none;
}

.loading-modal-modalContent-u5C0f {
  display: flex;
  justify-content: center;
  margin: 28px 0px 0px;
}

.loading-modal-circularProgress-_qTA1 .rmwc-circular-progress__path {
  stroke-width: 4px;
  color: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/loading-modal/loading-modal.module.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":["@import url('@rmwc/circular-progress/circular-progress.css');\n\n.card {\n  width: 312px;\n  min-height: 0px;\n  height: 212px;\n}\n\n.modalToolbar_container {\n  border-bottom: none;\n}\n\n.modalContent {\n  display: flex;\n  justify-content: center;\n  margin: 28px 0px 0px;\n}\n\n.circularProgress :global(.rmwc-circular-progress__path) {\n  stroke-width: 4px;\n  color: var(--accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `loading-modal-card-ek0XE`,
	"modalToolbar_container": `loading-modal-modalToolbar_container-QqL2y`,
	"modalContent": `loading-modal-modalContent-u5C0f`,
	"circularProgress": `loading-modal-circularProgress-_qTA1`
};
export default ___CSS_LOADER_EXPORT___;
